import { type HTMLArkProps, ark } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

type LinkElement = React.ElementRef<"a">;

interface LinkProps extends HTMLArkProps<"a"> {
  size?: "sm" | "md" | "lg" | "inherit";
  color?: "red" | "blue";
}

const Link = React.forwardRef<LinkElement, LinkProps>((props, ref) => {
  const { className, size = "inherit", color = "red", ...rest } = props;
  return (
    <ark.a
      ref={ref}
      data-size={size}
      data-color={color}
      className={clsx("ox-reset ox-Link", className)}
      {...rest}
    />
  );
});
Link.displayName = "Link";
export { Link };
export type { LinkProps };
